import React from "react";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";

const OPTIONS = [
  {
    value: "course",
    label: "Course",
    icon: SchoolRoundedIcon,
    hint: "Your course work, classes and the papers your course includes.",
  },
  {
    value: "mobile",
    label: "Mobile plan",
    icon: PhoneIphoneRoundedIcon,
    hint: "Your full mobile plan library: worksheets, mock exams and practice papers.",
  },
];

/**
 * Course ⇄ Mobile plan switch for a student who has both, shown in the Student Portal top
 * bar beside Practice. Each side keeps its own lists and scores; the tooltip says which.
 * `compact` drops the labels on small screens.
 */
export default function DashboardViewToggle({ value, onChange, compact = false }) {
  const active = OPTIONS.find((o) => o.value === value) || OPTIONS[0];

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={active.value}
      onChange={(_, next) => next && next !== active.value && onChange(next)}
      aria-label="Choose which side of your account to show"
      sx={{
        p: 0.4,
        borderRadius: "12px",
        background: "rgba(255,255,255,0.12)",
        "& .MuiToggleButtonGroup-grouped": {
          border: 0,
          borderRadius: "9px !important",
          px: compact ? 0.9 : 1.4,
          py: 0.4,
          gap: 0.75,
          textTransform: "none",
          fontWeight: 700,
          fontSize: "0.78rem",
          lineHeight: 1.4,
          color: "#fff",
          "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
          "&.Mui-selected, &.Mui-selected:hover": {
            bgcolor: "#fff",
            color: "#5b3f86",
          },
          "&.Mui-focusVisible": {
            outline: "2px solid #fff",
            outlineOffset: 1,
          },
        },
      }}
    >
      {OPTIONS.map(({ value: v, label, icon: Icon, hint }) => (
        <Tooltip key={v} title={hint} arrow>
          <ToggleButton value={v} aria-label={label}>
            <Icon sx={{ fontSize: 16 }} />
            {!compact && label}
          </ToggleButton>
        </Tooltip>
      ))}
    </ToggleButtonGroup>
  );
}
